import { z } from 'zod';

import type { ApiResult } from './client';
import { get } from './client';

export const timezoneSchema = z.object({
  id: z.string(),
  display_name: z.string(),
  utc_offset_minutes: z.number(),
});
export const timezoneListSchema = z.array(timezoneSchema);
export type Timezone = z.infer<typeof timezoneSchema>;

/**
 * Canonical IANA timezones from the DB (`/admin/timezones` — ~599 rows, active
 * only, ordered by UTC offset then id). FK-backed source of truth; the top-bar
 * clock picker and any timezone selector read from here, NOT a hardcoded list.
 */
export const listTimezones = (signal?: AbortSignal): Promise<ApiResult<Timezone[]>> =>
  get('/admin/timezones', timezoneListSchema, { signal }) as Promise<ApiResult<Timezone[]>>;
